import { PortfoliosSwitchSubPortfolioGroupsService_portfolioSwitchSubPortfolioGroupServicePostFrame } from '@festina/unitlink-general-types/unitlink/hooks/PortfoliosSwitchSubPortfolioGroupsService_portfolioSwitchSubPortfolioGroupServicePostFrame'

export const useFetchSwitchSubPortfolioGroupFrame =
  PortfoliosSwitchSubPortfolioGroupsService_portfolioSwitchSubPortfolioGroupServicePostFrame.useSuspenseQuery
